/**
 * WalletConnect mark pulled from the design node vector.
 */
export function WalletConnectIcon(props: {
  className?: string;
}): React.ReactElement {
  return (
    <svg
      className={`h-[10px] w-[16px] shrink-0 ${props.className ?? ''}`}
      viewBox="0 0 16 9.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.27556 1.8757C5.88476 -0.625232 10.1152 -0.625232 12.7245 1.8757L13.0385 2.17668C13.169 2.3017 13.169 2.50445 13.0385 2.62947L11.9643 3.65911C11.899 3.72162 11.7933 3.72162 11.7281 3.65911L11.2959 3.24492C9.47561 1.50022 6.5244 1.50022 4.70409 3.24492L4.24129 3.68848C4.17604 3.75099 4.07031 3.75099 4.00507 3.68848L2.93086 2.65883C2.80038 2.53381 2.80038 2.33106 2.93086 2.20604L3.27556 1.8757ZM14.9461 4.00504L15.9021 4.92141C16.0326 5.04643 16.0326 5.24918 15.9021 5.3742L11.5912 9.50619C11.4607 9.63127 11.2492 9.63127 11.1187 9.50619L8.05909 6.57363C8.02647 6.54235 7.9736 6.54235 7.94098 6.57363L4.88135 9.50619C4.75092 9.63127 4.5394 9.63127 4.40891 9.50619L0.0978475 5.37414C-0.0326158 5.24912 -0.0326158 5.04637 0.0978475 4.92135L1.05391 4.00498C1.18438 3.8799 1.3959 3.8799 1.52636 4.00498L4.58605 6.9376C4.61867 6.96889 4.67153 6.96889 4.70415 6.9376L7.76373 4.00498C7.89415 3.8799 8.10568 3.8799 8.23616 4.00498L11.2959 6.9376C11.3285 6.96889 11.3813 6.96889 11.414 6.9376L14.4737 4.00504C14.6041 3.87996 14.8156 3.87996 14.9461 4.00504Z"
        fill="#27272A"
      />
    </svg>
  );
}
